'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

import { isAuthenticated } from '@/lib/auth';

export default function Home() {
  const router = useRouter();
  useEffect(() => {
    if (isAuthenticated()) {
      // ADR-216 Faz-A: the authenticated default surface is the canonical /v2.
      // Deep-links (e.g. /dashboard) are untouched — this is only the root default.
      router.replace('/v2');
    } else {
      router.replace('/login/');
    }
  }, [router]);
  return null;
}
